import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios';


const initialState = {
    pendingOrders : [],
    pendingGroupOrders : [],
    isLoading : false,
    error : '',
}

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
const API_URL = `${BACKEND_URL}/api/order/pending`;

//Register Pending Order
export const registerPendingOrder = createAsyncThunk(
  "pendingOrder/register",
  async(formData, thunkAPI) => {
    try {
        const response = await axios.post(API_URL, formData)
        console.log(response)
        return response.data
    } catch (error) {
      const message = (
        error.response && error.response.data 
        && error.response.data.message) 
        || error.message || error.toString();
        console.log(message)
        return thunkAPI.rejectWithValue(message)
    }
  }
)

//Get All Pending Orders
export const getPendingOrders = createAsyncThunk(
  "pendingOrder/getAll",
  async(_, thunkAPI) => {
    try {
        const response = await axios.get(API_URL)
        return response.data
    } catch (error) {
      const message = (
        error.response && error.response.data 
        && error.response.data.message) 
        || error.message || error.toString();
        console.log(message)
        return thunkAPI.rejectWithValue(message)
    }
  }
)

//Get All Pending Orders Group by Smile
export const getPendingOrdersWithGroup = createAsyncThunk(
  "pendingOrder/getAllWithGroup",
  async(_, thunkAPI) => {
    try {
        const response = await axios.get(API_URL + 'group')
        //console.log(response.data)
        return response.data
    } catch (error) {
      const message = (
        error.response && error.response.data 
        && error.response.data.message) 
        || error.message || error.toString();
        console.log(message)
        return thunkAPI.rejectWithValue(message)
    }
  }
)


/* //Sace Pending Order
export const getWebsite = createAsyncThunk(
  "website/getOne",
  async(id, thunkAPI) => {
    try {
        const response = await axios.get(API_URL + id)
        return response.data
    } catch (error) {
      const message = (
        error.response && error.response.data 
        && error.response.data.message) 
        || error.message || error.toString();
        console.log(message)
        return thunkAPI.rejectWithValue(message)
    }
  }
) */

const pendingOrderSlice = createSlice({
  name: "pendingOrder",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(registerPendingOrder.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(registerPendingOrder.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pendingOrders.push(action.payload);
      })
      .addCase(registerPendingOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      })
      .addCase(getPendingOrders.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getPendingOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pendingOrders = (action.payload);
      })
      .addCase(getPendingOrders.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      })
      .addCase(getPendingOrdersWithGroup.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getPendingOrdersWithGroup.fulfilled, (state, action) => {
        state.isLoading = false;
        state.pendingGroupOrders = (action.payload);
      })
      .addCase(getPendingOrdersWithGroup.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload
      })
  }
});
export const selectPendingOrders = (state) => state.pendingOrder.pendingOrders
export const selectpendingGroupOrders = (state) => state.pendingOrder.pendingGroupOrders

export default pendingOrderSlice.reducer